/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EmployeeRole {
  EMPLOYEE = 'EMPLOYEE',
  EMPLOYER_ADMIN = 'EMPLOYER_ADMIN',
  OTHER = 'OTHER',
}
